import { readFileSync } from "fs";
import path from "path";
import { resolvePath } from "@vxrn/resolve";
var DEVTOOLS_VIRTUAL_ID = "/@one/dev.js";
function createDevtoolsPlugin() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var { includeUI = true } = options;
  return {
    name: "one-devtools",
    apply: "serve",
    // only in dev
    configureServer(server) {
      var _server_config_experimental;
      var isBundledDev = !!((_server_config_experimental = server.config.experimental) === null || _server_config_experimental === void 0 ? void 0 : _server_config_experimental.bundledDev);
      server.middlewares.use(async function(req, res, next) {
        if (req.url === DEVTOOLS_VIRTUAL_ID) {
          try {
            var devEntryPath = resolvePath("one/devtools/dev.mjs");
            var devEntry = readFileSync(devEntryPath, "utf-8");
            var code = devEntry.replace("import './devtools.mjs'", "").replace("import './source-inspector.mjs'", "");
            if (isBundledDev) {
              code = code.replace("import { createHotContext } from '/@vite/client'", "const createHotContext = () => ({ on() {}, off() {}, accept() {}, dispose() {}, prune() {}, send() {}, invalidate() {} })").replace("import { injectIntoGlobalHook } from '/@react-refresh'", "const injectIntoGlobalHook = () => {}");
            }
            if (includeUI) {
              var devtoolsPath = resolvePath("one/devtools/devtools.mjs");
              var sourceInspectorPath = resolvePath("one/devtools/source-inspector.mjs");
              var devtools = readFileSync(devtoolsPath, "utf-8");
              var sourceInspector = readFileSync(sourceInspectorPath, "utf-8");
              var projectName = path.basename(process.cwd());
              code = `window.__oneProjectRoot="${projectName}";
${code}
${devtools}
${sourceInspector}`;
            }
            res.setHeader("Content-Type", "application/javascript");
            res.setHeader("Cache-Control", "no-store");
            res.end(code);
            return;
          } catch (e) {
            console.error("[one] Failed to load devtools script:", e);
          }
          res.setHeader("Content-Type", "application/javascript");
          res.end("// devtools failed to load");
          return;
        }
        next();
      });
    }
  };
}
export {
  DEVTOOLS_VIRTUAL_ID,
  createDevtoolsPlugin
};
//# sourceMappingURL=devtoolsPlugin.js.map
